<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/" style="background-color: white; border-radius: 0.7rem;">
                <img src="img/brand/logo-white.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img src="img/brand/logo.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown tag="li">
                    <a slot="title" href="http://okfishing.sunsang24.com/ship/schedule_fleet" target="_blank" class="nav-link" data-toggle="dropdown" role="button">
                        <base-button tag="a"
                                    href="http://okfishing.sunsang24.com/ship/schedule_fleet"
                                    target="_blank"
                                    class="mb-3 mb-sm-0"
                                    type="danger">
                                    <!-- href="writeBooking" -->
                                    🚢 출항일정/예약하기
                        </base-button>
                    </a>
                </base-dropdown>
                <base-dropdown tag="li" class="">
                    <a slot="title" href="/baitingInfo" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">조황정보</span>
                    </a>
                </base-dropdown>
                <base-dropdown tag="li">
                    <a slot="title" href="/introduce" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">선박소개</span>
                    </a>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">문의하기</span>
                    </a>
                    <router-link to="/customer" class="dropdown-item">1:1 문의하기</router-link>
                    <router-link to="/benefit" class="dropdown-item">환불규정</router-link>
                </base-dropdown>
                <base-dropdown tag="li">
                    <a slot="title" href="/weatherInfo" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">기상안내</span>
                    </a>
                </base-dropdown>
                <base-dropdown tag="li">
                    <a slot="title" href="/location" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">오시는 길</span>
                    </a>
                </base-dropdown>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
.font-black{
    color:black;
}

.navbar-expand-lg > .container, .navbar-expand-lg > .container-fluid {
    background: black !important;
    border-radius: 1rem !important;
}
</style>
